import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * `fontSize` custom keys from tailwind.config.js (`type-*`). Without this,
 * tailwind-merge can't recognize `text-type-*` as a font-size utility and
 * falls back to bucketing it under `text-color`, silently dropping whichever
 * of the two (real color class vs. `text-type-*`) came first — e.g. it wiped
 * out `text-sage-50` on the landing page CTA button. Keep in sync with
 * `tailwind.config.js` `theme.extend.fontSize`.
 */
const dsFontSizeKeys = [
  'type-display-hero', 'type-display-hero-lg', 'type-display-hero-glass',
  'type-display-kpi', 'type-display-metric', 'type-display-stat', 'type-display-row',
  'type-title-page', 'type-title-page-lg', 'type-title-card',
  'type-body', 'type-body-sm', 'type-label', 'type-label-lg', 'type-section', 'type-chip',
  'type-landing-hero-sm', 'type-landing-hero-md', 'type-landing-hero-lg',
  'type-landing-h2-sm', 'type-landing-h2-md', 'type-landing-h2-lg',
  'type-landing-lead-sm', 'type-landing-lead-md', 'type-landing-lead-lg',
];

/**
 * `$space-*` do .pen (`tailwind.config.js` `theme.extend.spacing`). Sem isto,
 * tailwind-merge não reconhece `px-space-5`/`gap-space-4`/etc. como parte dos
 * grupos padding/gap/width/height/inset — duas classes conflituosas (ex.:
 * `px-space-5` de uma variante + `px-0` de um override) ficam as DUAS no
 * className final em vez de a última ganhar, e o resultado visual depende de
 * qual delas o Tailwind gerou por último no stylesheet (não da ordem do
 * className) — bug real já apanhado em botões ghost com padding customizado
 * (ícones a renderizar com width:0). Extender `theme.spacing` corrige todos
 * os grupos que o referenciam de uma vez (padding, margin, gap, w/h, inset).
 */
const dsSpacingKeys = [
  'space-1', 'space-2', 'space-2-5', 'space-3', 'space-4', 'space-5', 'space-6',
  'space-8', 'space-10', 'space-12', 'space-16', 'space-20', 'space-24',
];

/** `$radius-*` do .pen (`theme.extend.borderRadius`) — mesmo raciocínio para `rounded-ds-*`. */
const dsRadiusKeys = ['ds-sm', 'ds-md', 'ds-lg', 'ds-xl', 'ds-full'];

const twMerge = extendTailwindMerge({
  extend: {
    theme: { spacing: dsSpacingKeys, radius: dsRadiusKeys },
    classGroups: { 'font-size': [{ text: dsFontSizeKeys }] },
  },
});

/**
 * Combine class names with clsx + tailwind-merge to ensure conflicts are
 * resolved deterministically (later wins). Padrao shadcn.
 *
 * @param  {...any} inputs
 * @returns {string}
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
